"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tooltip;

var _TooltipModule = _interopRequireDefault(require("../../assets/styles/components/Tooltip.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Tooltip(_ref) {
  let {
    children,
    text = "",
    arrow = false,
    position = "top",
    styling = {},
    size = "compact"
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: _TooltipModule.default.tooltip,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      style: styling,
      className: "\n                ".concat(_TooltipModule.default.tooltiptext, "\n                ").concat(arrow && _TooltipModule.default.arrow, "\n                ").concat(size === "mini" ? _TooltipModule.default.size_mini : size === "compact" ? _TooltipModule.default.size_compact : size === "default" ? _TooltipModule.default.size_default : size === "large" ? _TooltipModule.default.size_large : _TooltipModule.default.size_default, "\n                ").concat(position === "top-start" ? _TooltipModule.default.position_topstart : position === "top" ? _TooltipModule.default.position_top : position === "top-end" ? _TooltipModule.default.position_topend : position === "right-start" ? _TooltipModule.default.position_rightstart : position === "right" ? _TooltipModule.default.position_right : position === "right-end" ? _TooltipModule.default.position_rightend : position === "bottom-end" ? _TooltipModule.default.position_bottomend : position === "bottom" ? _TooltipModule.default.position_bottom : position === "bottom-start" ? _TooltipModule.default.position_bottomstart : position === "left-end" ? _TooltipModule.default.position_leftend : position === "left" ? _TooltipModule.default.position_left : position === "left-start" ? _TooltipModule.default.position_leftstart : _TooltipModule.default.position_top),
      children: text
    }), children]
  });
}